import type { ClientFrame, HostFrame } from "../protocol/frames";
import { createHost } from "./createHost";
import { createSocketAdapter, type SocketAdapter } from "./socketAdapter";
import type { KernelTransport } from "./transport";

export interface CreateInProcessTransportOptions {
  adapter?: SocketAdapter;
}

export const createInProcessTransport = ({
  adapter = createSocketAdapter(),
}: CreateInProcessTransportOptions = {}): KernelTransport => {
  const listeners = new Set<(frame: HostFrame) => void>();
  const host = createHost({ adapter });

  const emit = (frame: HostFrame) => {
    for (const listener of [...listeners]) {
      listener(frame);
    }
  };

  const session = host.connect({ post: emit });

  const post = (frame: ClientFrame) => {
    session.receive(frame);
  };

  const subscribe = (listener: (frame: HostFrame) => void) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  };

  const close = () => {
    session.disconnect();
    listeners.clear();
  };

  return {
    post,
    subscribe,
    close,
  };
};
